<app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

<div class="container px-0 mt-5">
    <div class="grid grid-cols-3 gap-4">
        <div class="col-span-2">
            <form [formGroup]="generalForm">
                <mat-form-field>
                    <mat-label>{{'COMMON.FIRST_NAME' | translate}}</mat-label>
                    <input formControlName="firstName" class="border-transparent focus:border-transparent focus:ring-0"
                        matInput placeholder="{{'COMMON.LAST_NAME' | translate}}" />
                    @if (generalForm.controls['firstName'].hasError('required')) {
                    <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                    }
                </mat-form-field>

                <mat-form-field class="ms-5">
                    <mat-label>{{'COMMON.LAST_NAME' | translate}}</mat-label>
                    <input formControlName="lastName" class="border-transparent focus:border-transparent focus:ring-0"
                        matInput placeholder="{{'COMMON.LAST_NAME' | translate}}" />
                    @if (generalForm.controls['lastName'].hasError('required')) {
                    <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                    }
                </mat-form-field>
            </form>
        </div>
        <div></div>
    </div>
    <!-- // banner -->
    <div class="w-full flex items-center bg-[#e4cf534d] text-[#726729] p-2" *ngIf="!enableEditRole">
        <mat-icon>report_problem_outline</mat-icon>
        <span class="ms-2">{{cannotEditUserRoleWarning}}</span>
    </div>
    <div class="col-span-2">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="{{'COMMON.INFORMATION' | translate}}">
                <ng-template matTabContent>
                    <form [formGroup]="generalForm">
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field>
                                <mat-label>{{'COMMON.EMAIL' | translate}}</mat-label>
                                <input formControlName="email" type="email"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                                @if (generalForm.controls['email'].hasError('email') &&
                                !generalForm.controls['email'].hasError('required')) {
                                <mat-error>Please enter a valid email address</mat-error>
                                }
                                @if (generalForm.controls['email'].hasError('required')) {
                                <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field>
                                <mat-label>{{'COMMON.USER_NAME' | translate}}</mat-label>
                                <input formControlName="loginName" (blur)="onCheckExist()"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                                <mat-hint *ngIf="isExistedLoginName" class="error">
                                    {{'USER.USERNAME_EXIST' | translate}}</mat-hint>
                                @if (generalForm.controls['loginName'].hasError('pattern') &&
                                !generalForm.controls['loginName'].hasError('required')) {
                                <mat-error> {{ 'USER.USER_NAME_CONTAIN_SPACE' | translate }}</mat-error>
                                }
                                @if (generalForm.controls['loginName'].hasError('required')) {
                                <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{'COMMON.DOMAIN' | translate}}</mat-label>
                                <input formControlName="loginDomain"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field *ngIf="isAddMode">
                                <mat-label>{{'COMMON.PASSWORD' | translate}}</mat-label>
                                <input formControlName="password" type="password"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                                @if (generalForm.controls['password'].hasError('required')) {
                                <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field (click)="onEditPassword(changePassTemplate)" *ngIf="!isAddMode">
                                <mat-label>{{'COMMON.PASSWORD' | translate}}</mat-label>
                                <input type="password" readonly value="netpower"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                                <button matSuffix mat-icon-button aria-label="Clear">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{'COMMON.REPEAT_PASSWORD' | translate}}</mat-label>
                                <input formControlName="repeatPassword" type="password"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                                @if (generalForm.controls['repeatPassword'].hasError('confirmedValidator') &&
                                !generalForm.controls['repeatPassword'].hasError('required')) {
                                <mat-error>{{'USER.REPEAT_PASSWORD_NOT_MATCH_PASSWORD' |
                                    translate}}</mat-error>
                                }
                                @if (generalForm.controls['repeatPassword'].hasError('required')) {
                                <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field (click)="onClickSelectDepartment()">
                                <mat-label>{{'DEPARTMENTS.DEPARTMENT' | translate}}</mat-label>
                                <input formControlName="departmentName" readonly
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                                <button matSuffix mat-icon-button>
                                    <mat-icon>arrow_drop_down</mat-icon>
                                </button>
                                @if (generalForm.controls['departmentId'].hasError('required')) {
                                <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{'COMMON.TITLE' | translate}}</mat-label>
                                <input formControlName="title"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-1 gap-10 mt-5">
                            <mat-form-field>
                                <mat-label>{{'COMMON.COMMENT' | translate}}</mat-label>
                                <textarea formControlName="comment" cdkAutosizeMinRows="3"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    maxlength="4000" #autosize="cdkTextareaAutosize" cdkTextareaAutosize></textarea>
                            </mat-form-field>
                        </div>
                    </form>
                </ng-template>
            </mat-tab>
            <mat-tab label="{{'COMMON.ADDRESS_AND_TELEPHONE' | translate}}">
                <ng-template matTabContent>
                    <form [formGroup]="generalForm">
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field>
                                <mat-label>{{'COMMON.ADDRESS' | translate}}</mat-label>
                                <input formControlName="address"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{'COMMON.PLACE' | translate}}</mat-label>
                                <input formControlName="place"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field>
                                <mat-label>{{'COMMON.TELEPHONE_HOME' | translate}}</mat-label>
                                <input formControlName="phoneHome"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{'COMMON.TELEPHONE_WORK' | translate}}</mat-label>
                                <input formControlName="phoneWork"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field>
                                <mat-label>{{'COMMON.TELEPHONE_MOBILE' | translate}}</mat-label>
                                <input formControlName="phoneMobile"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{'COMMON.TELEPHONE_INTERNAL' | translate}}</mat-label>
                                <input formControlName="phoneInternal"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field>
                                <mat-label>{{'COMMON.PAGER' | translate}}</mat-label>
                                <input formControlName="beeper"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{'COMMON.CALLING' | translate}}</mat-label>
                                <input formControlName="callNumber"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>
                        </div>
                        <div class="grid grid-cols-2 gap-10 mt-5">
                            <mat-form-field>
                                <mat-label>{{'COMMON.FAX' | translate}}</mat-label>
                                <input formControlName="fax"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{'COMMON.ZIP_CODE' | translate}}</mat-label>
                                <input formControlName="zipCode"
                                    class="border-transparent focus:border-transparent focus:ring-0" matInput
                                    placeholder="" />
                            </mat-form-field>
                        </div>
                    </form>
                </ng-template>
            </mat-tab>
            <mat-tab label="{{'ROLE.ROLE' | translate}}">
                <ng-template matTabContent>
                    <div class="mt-5">
                        <button (click)="openRoleDialog()" *ngIf="!disableModeUpsertUser" [disabled]="!enableEditRole"
                            color="primary" mat-stroked-button>
                            <mat-icon>add</mat-icon> {{'USER.ADD_NEW_ROLE' | translate}}
                        </button>
                        <div class="mt-5">
                            <table mat-table class="ws-table" [dataSource]="dataSource">

                                <ng-container matColumnDef="select">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <div class="flex items-center">
                                            <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null"
                                                [checked]="selection.hasValue() && isAllSelected()"
                                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                                [aria-label]="checkboxLabel()">
                                            </mat-checkbox>
                                            <button *ngIf="selection.selected && selection.selected.length > 0"
                                                mat-icon-button aria-label="close dialog" mat-dialog-close
                                                (click)="bulkDeleteRole()">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let row">
                                        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                            (change)="$event ? selection.toggle(row) : null"
                                            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> {{'COMMON.NAME' | translate}} </th>
                                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="description">
                                    <th mat-header-cell *matHeaderCellDef> {{'COMMON.DESCRIPTION' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>

                        </div>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <div class="flex justify-end mt-5">
            <button class="me-5" color="primary" [routerLink]="['/admin/users']" mat-stroked-button>
                {{'COMMON.CANCEL' | translate}}
            </button>

            <button color="primary" [disabled]="disabledSaveButton" *ngIf="!disableModeUpsertUser" (click)="onSubmit()"
                mat-flat-button>
                {{'COMMON.SAVE' | translate}}
            </button>
        </div>
    </div>

</div>

<ng-template #changePassTemplate>
    <div class="p-4">
        <div class="change-pass-dialog__header">
            <div mat-dialog-title class="flex justify-between">
                <h5 class="title">
                    {{ 'COMMON.CHANGE_PASSWORD' | translate }}
                </h5>
                <button mat-icon-button aria-label="close dialog" mat-dialog-close
                    (click)="onCancelChangePasswordClick()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <div class="change-pass-dialog__body">
            <form [formGroup]="generalForm">
                <mat-form-field class="w-full">
                    <mat-label>{{'COMMON.PASSWORD' | translate}}</mat-label>
                    <input formControlName="password" type="password"
                        class="border-transparent focus:border-transparent focus:ring-0" matInput placeholder="" />
                    @if (generalForm.controls['password'].hasError('required')) {
                    <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                    }
                </mat-form-field>

                <mat-form-field class="w-full">
                    <mat-label>{{'COMMON.REPEAT_PASSWORD' | translate}}</mat-label>
                    <input formControlName="repeatPassword" type="password"
                        class="border-transparent focus:border-transparent focus:ring-0" matInput placeholder="" />
                    @if (generalForm.controls['repeatPassword'].hasError('confirmedValidator') &&
                    !generalForm.controls['repeatPassword'].hasError('required')) {
                    <mat-error>{{'USER.REPEAT_PASSWORD_NOT_MATCH_PASSWORD' |
                        translate}}</mat-error>
                    }
                    @if (generalForm.controls['repeatPassword'].hasError('required')) {
                    <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                    }
                </mat-form-field>
            </form>
        </div>

        <div class="flex justify-end mt-5">
            <button class="me-5" color="primary" (click)="onCancelChangePasswordClick()" mat-stroked-button>
                {{'COMMON.CANCEL' | translate}}
            </button>

            <button color="primary"
                [disabled]="!generalForm.value.password || !generalForm.value.repeatPassword || (generalForm.value.password !== generalForm.value.repeatPassword)"
                (click)="onConfirmChangePasswordClick()" mat-flat-button>
                {{'COMMON.SAVE' | translate}}
            </button>
        </div>
    </div>
</ng-template>